export default {
    path: 'admin_invoice',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/examine/ExamineList'),
	name:'admin_invoice',
    meta: {title:'开票审核',keepAlive:true},
    children: [
        {
            path: 'detail',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/common/invoiceDetails'),
            meta: { title: '申请详情' },
        },
		{
		path: 'laowu_detail',
		component: () => import(/* webpackChunkName: "article-create" */ '@/pages/examine/laowuDetail'),
		meta: { title: '开票详情' },
		},
    ]
}